export const categories = [
  { slug: "all", name: "全部", icon: "ri-stack-line" },
  { slug: "romance", name: "恋爱", icon: "ri-heart-line" },
  { slug: "fantasy", name: "奇幻", icon: "ri-magic-line" },
  { slug: "action", name: "动作", icon: "ri-sword-line" },
  { slug: "mystery", name: "悬疑", icon: "ri-search-eye-line" },
  { slug: "comedy", name: "搞笑", icon: "ri-emotion-laugh-line" },
  { slug: "bl", name: "耽美", icon: "ri-star-line" },
  { slug: "drama", name: "剧情", icon: "ri-film-line" },
  { slug: "horror", name: "惊悚", icon: "ri-ghost-line" },
];

export const categoryNames: Record<string, string> = {
  all: "全部漫画",
  romance: "恋爱漫画",
  fantasy: "奇幻漫画",
  action: "动作漫画",
  mystery: "悬疑漫画",
  comedy: "搞笑漫画",
  bl: "耽美漫画",
  drama: "剧情漫画",
  horror: "惊悚漫画",
};

export const categoryDescriptions: Record<string, string> = {
  all: "浏览全部韩国漫画作品，发现最新最热的韩漫推荐。",
  romance: "甜蜜浪漫的韩国恋爱漫画推荐，从校园初恋到成人爱情，总有一部打动你的心。",
  fantasy: "奇幻瑰丽的韩国奇幻漫画，带你进入魔法、异世界与神话交织的精彩冒险。",
  action: "热血沸腾的韩国动作漫画，拳拳到肉的战斗场面与惊险刺激的剧情发展。",
  mystery: "悬疑烧脑的韩国悬疑漫画，层层递进的推理与出人意料的结局反转。",
  comedy: "笑料百出的韩国搞笑漫画，轻松幽默的日常故事让你忘却烦恼。",
  bl: "精选韩国耽美漫画推荐，细腻动人的情感描绘与唯美画风。",
  drama: "扣人心弦的韩国剧情漫画，深刻的人物刻画与引人入胜的故事发展。",
  horror: "惊悚刺激的韩国恐怖漫画，令人毛骨悚然的情节与紧张氛围的极致呈现。",
};